import jazzicon from "@metamask/jazzicon";

export const getJazziconAvatar = (address: string): HTMLElement => {
  if (!address) return null;

  const newAddress = address.slice(2, 10);
  const seed = parseInt(newAddress, 16);
  return jazzicon(32, seed);
};
